import { Base } from '@models/base.model';
import { PageObject } from '@models/page-object.model';
import { alias, deserialize, serializable } from 'serializr';
import { Screenshot } from '../enums/screenshot.enum';
import { RecoverAction } from '../enums/recover-action.enum';
import { OnAbortedAction } from '../enums/on-aborted-action.enum';
import { ScreenshotMode } from '@enums/screenshot-mode.enum';
import { PreRequisiteAction } from '../enums/pre-requisite-action.enum';

export class ExecutionDetails extends Base implements PageObject {
  @serializable(alias('page_timeout'))
  public pageTimeout: number;

  @serializable(alias('step_timeout'))
  public stepTimeout: number;

  @serializable(alias('recovery_action'))
  public recoveryAction: RecoverAction;

  @serializable(alias('on_aborted_action'))
  public onAbortedAction: OnAbortedAction;

  @serializable(alias('screenshot_option'))
  public screenshotOption: Screenshot;

  @serializable(alias('screenshot_mode'))
  public screenshotMode: ScreenshotMode;

  @serializable(alias('group_prerequisite_fail'))
  public groupPrerequisiteFail: PreRequisiteAction;

  @serializable(alias('test_case_prerequisite_fail'))
  public testCasePrerequisiteFail: PreRequisiteAction;

  @serializable(alias('test_step_prerequisite_fail'))
  public testStepPrerequisiteFail: RecoverAction;

  @serializable(alias('global_param_name'))
  public globalParamName: string;

  @serializable(alias('is_accessibility_testing_enabled'))
  public isAccessibilityTestingEnabled: boolean;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(ExecutionDetails, input));
  }
}
